import { useContentful } from '../../hooks/useContentful'
import RegularLayout from '../../layouts/Regular/Regular'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import PageContainer from '../../layouts/PageContainer/PageContainer'
import { components, formatDataForMyComponent } from './Components'
import NotFoundPage from '../NotFound/NotFound'
import ComingSoonPage from '../ComingSoon/ComingSoonPage'

const Page = () => {
  const { slug } = useParams()
  const { contentfulData, loaded } = useContentful('page')
  const [pageData, setPageData] = useState()
  const filterPage = (page) => page.fields.pageUrl === slug

  useEffect(() => {
    if (loaded) {
      const data = contentfulData.items.find(filterPage)

      if (data) {
        setPageData(data.fields)
      }
    }
  }, [loaded, slug])

  if (loaded && slug === 'coming-soon') {
    return <ComingSoonPage />
  }
  if (loaded && !pageData) {
    return <NotFoundPage />
  }
  return (
    <RegularLayout pathname={slug}>
      {pageData?.components &&
        pageData?.components.map((component) => {
          const Component = components[component.sys.contentType.sys.id]
          if (Component) {
            const props = formatDataForMyComponent(component)
            console.log(pageData)
            return (
              <PageContainer
                isThin={component.fields.isThin}
                hasDivider={component.fields.hasDivider}
                showLoadingState={!loaded}
                key={component.sys.id}>
                <Component {...props} />
              </PageContainer>
            )
          }

          return null
        })}
    </RegularLayout>
  )
}

export default Page
